export * from './real-property-data.reducer';
